import {
  GroupMember,
  Product,
  SelectedProduct,
} from "~/common/Store/models/ProductListing";
import isActiveSale from "./isActiveSale";

export default (
  product: Product,
  selectedGroupMember: GroupMember,
  setSelectedProduct: React.Dispatch<React.SetStateAction<SelectedProduct>>,
  isInStockOverride?: boolean,
) => {
  const memberAvailable =
    selectedGroupMember.memberAvailability?.available ?? true;

  setSelectedProduct({
    price: selectedGroupMember.price,
    unitOfMeasure: selectedGroupMember.unitOfMeasurement,
    startBuy: selectedGroupMember.startBuy,
    minimumBuy: selectedGroupMember.minimumBuy,
    mustBuy: selectedGroupMember.mustBuy,
    isInStock:
      isInStockOverride ?? (selectedGroupMember.isInStock && memberAvailable),
    showBelowMinimumAdvertisedPriceForLoggedInCustomers:
      product.showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers:
      product.showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
    activeSale: isActiveSale(selectedGroupMember.price),
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
    itemNumber: selectedGroupMember.itemNumber,
    primaryImagePath: selectedGroupMember.primaryImagePath,
    secondaryImagePath: selectedGroupMember.secondaryImagePath,
    descriptionHtml: selectedGroupMember.displayName,
    link: selectedGroupMember.link,
    isWebstaurantPlusEligible: selectedGroupMember.isWebstaurantPlusEligible,
    isNewProduct: selectedGroupMember.isNewProduct,
    hasFreeShipping: selectedGroupMember.hasFreeShipping,
    isCustomizable: selectedGroupMember.isCustomizable,
    customizationRequired: selectedGroupMember.customizationRequired,
    customizationUrl: selectedGroupMember.customizationUrl,
    divideByUnit: selectedGroupMember.divideByUnit,
    divideQuantity: selectedGroupMember.divideQuantity,
    minimumCustomizationPrice: selectedGroupMember.minimumCustomizationPrice,
    unitsPerPackaging: selectedGroupMember.unitsPerPackaging,
    productBadges: selectedGroupMember.productBadges,
  });
};
